import { render } from "./FechaVence.vue?vue&type=template&id=1400f904&scoped=true"
import script from "./FechaVence.vue?vue&type=script&lang=js"
export * from "./FechaVence.vue?vue&type=script&lang=js"

import "./FechaVence.vue?vue&type=style&index=0&id=1400f904&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1400f904"]])

export default __exports__